import { IFormParams } from '@epi-models/containers/MaksturvaNewPaymentPage';

import createReducer from '../../helpers/CreateReducer';
import { ApiConstants } from '../../constants/actions';

interface PaymentsState {
  newPaymentParams: {
    actionUrl: string;
    formParams: IFormParams[];
  } | null | null;
  isError: boolean;
  noPersistance: boolean;
}

export const getInitialState = (): PaymentsState => ({
  newPaymentParams: null,
  isError: false,
  noPersistance: true
});

export default createReducer(getInitialState, {
  [`${ApiConstants.CREATE_NEW_PAYMENT}_REQUEST`]:
    (): Partial<PaymentsState> => ({
      newPaymentParams: null,
      isError: false
    }),

  [`${ApiConstants.CREATE_NEW_PAYMENT}_SUCCESS`]: (
    state: PaymentsState,
    {
      payload
    }: {
      payload: {
        actionUrl: string;
        formParams: IFormParams[];
      };
    }
  ): Partial<PaymentsState> => ({
    newPaymentParams: payload
  }),

  [`${ApiConstants.CREATE_NEW_PAYMENT}_FAILURE`]:
    (): Partial<PaymentsState> => ({
      newPaymentParams: null,
      isError: true
    })
});
